import axios from 'axios';
import { handleRequestError } from '../requests';

// DTO for ContainerSummary
export interface ContainerSummaryDTO {
  containerId: string;
  n2Level?: number;
  n2LevelTs?: string;
  n2Pressure?: number;
  n2PressureTs?: string;
  heLevel?: number;
  heLevelTs?: string;
  hePressure?: number;
  hePressureTs?: string;
  batteryLevel?: number;
  batteryLevelTs?: string;
  ambientTemperature?: number;
  ambientTemperatureTs?: string;
  latitude?: number;
  latitudeTs?: string;
  longitude?: number;
  longitudeTs?: string;
  currentLocation: string;
  lastKnownLocation: string;
}

// Calls the backend ContainerTrackingController to get container summaries
export async function getContainerSummaries(dist: number, months: number): Promise<ContainerSummaryDTO[]> {
  const response = await axios.get('/ContainerTracking/GetContainerSummaries', {
    params: { dist: 10, months: -3 }
  }).catch(handleRequestError);
  return response.data;
}

export async function GetN2AndHeMetrics(
  {containerLabel,
  days,
  rank}
): Promise<any> {
  const response = await axios.get('/ContainerTracking/GetN2AndHeMetrics', {
    params: { containerLabel, days, rank }
  }).catch(handleRequestError);
  return response.data;
}
